import { GridApi } from 'ag-grid-community';
import { NgxPermissionsService } from 'ngx-permissions';

import { FeatureFlagValue } from '@app/feature-toggle-list';
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';
import { FulfillmentOrdersGridActionService } from 'v2/modules/order/components/order-fulfillments-grid/services/fulfillment-orders-grid-action.service';

import { IAgGridDropdownMenuOption } from '../../components/ag-grid-dropdown-menu-cell-renderer/ag-grid-dropdown-menu-cell-renderer.component';

export class BaseGridActionService {
  protected gridApi :GridApi | null = null;

  constructor(
    protected featureToggleService :FeatureToggleService,
    protected permissionsService :NgxPermissionsService,
  ) {}

  setGridApi(api :GridApi) :void {
    this.gridApi = api;
  }

  refreshGrid() :void {
    // Trigger this condition first so that prevents double trigger refreshServerSide for fulfillment orders grid
    if (this instanceof FulfillmentOrdersGridActionService) {
      (this as FulfillmentOrdersGridActionService).triggerClearGridState();

      return;
    } else {
      console.warn('refreshGrid called from unknown service');
    }

    // Check if gridApi is set before calling refreshServerSide
    if (this.gridApi) {
      this.gridApi.refreshServerSide({ purge: true });
    } else {
      console.warn('Grid API not set');
    }
  }

  protected getFilteredDropdownOptions(
    actionDropdownOptions :IAgGridDropdownMenuOption[],
  ) :IAgGridDropdownMenuOption[] {
    return actionDropdownOptions.filter((option) => {
      // Check if the user has the required permissions
      const hasPermission =
        !option.permissions || this.userHasPermission(option.permissions);

      // Check feature flags, considering negation
      const hasFeatureFlag =
        !option.featureFlags ||
        option.featureFlags.every((flag) => {
          const isNegated = typeof flag === 'string' && flag.startsWith('!');
          const actualFlag = isNegated ? flag.substring(1) : flag;
          const isActive = this.featureToggleService.isActive(
            actualFlag as FeatureFlagValue,
          );

          return isNegated ? !isActive : isActive;
        });

      return hasPermission && hasFeatureFlag;
    });
  }

  private userHasPermission(userPermissions :string[]) :boolean {
    const acceptedPermissions = Object.keys(
      this.permissionsService.getPermissions(),
    );

    return acceptedPermissions.some((permission) =>
      userPermissions.includes(permission),
    );
  }
}
